// extracted by mini-css-extract-plugin
export default {"speak":"speak_speak__plf+T"};